import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    HostListener,
    inject,
    Input,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { QWYK_TABLE } from './table.component';

@Component({
    standalone: true,
    imports: [],
    selector: 'qwyk-sort-icon',
    template: `
        <i class="p-sortable-column-icon pi"
           [class.pi-sort]="!isActive"
           [class.pi-sort-amount-up-alt]="isAsc"
           [class.pi-sort-amount-down]="isDesc">
        </i>
    `,
    // Inline host styles give the icon a generous click target + visual feedback
    host: {
        '[style.display]': '"inline-flex"',
        '[style.alignItems]': '"center"',
        '[style.padding]': '"4px 6px"',
        '[style.cursor]': '"pointer"',
        '[style.borderRadius]': '"3px"',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class QwykSortIconComponent implements OnInit {
    @Input() field: string;

    private readonly _table = inject(QWYK_TABLE);
    private readonly _cdr = inject(ChangeDetectorRef);
    private readonly _destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this._table._sortState$
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe(() => this._cdr.markForCheck());
    }

    @HostListener('click', ['$event'])
    onClick(e: MouseEvent): void {
        e.stopPropagation(); // don't bubble to th or trigger reorder drag
        if (this.field) {
            this._table.sort(this.field);
        }
    }

    get isActive(): boolean {
        return this._table._sortField === this.field && this._table._sortOrder !== 0;
    }

    get isAsc(): boolean {
        return this._table._sortField === this.field && this._table._sortOrder === 1;
    }

    get isDesc(): boolean {
        return this._table._sortField === this.field && this._table._sortOrder === -1;
    }
}
